<template>
  <HgBadge theme="primarylight" :small="small">
    {{ t('listingStats.fields.badge') }}
    <HgIcon :class="$style.tenantPlusIcon" icon="TenantPlus" size="x-small" />
  </HgBadge>
</template>

<script lang="ts" setup>
import { HgBadge, HgIcon } from '@smg-real-estate/domus';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineOptions({
  name: 'TenantPlusBadge',
});

interface Props {
  small?: boolean;
}
withDefaults(defineProps<Props>(), {
  small: false,
});
</script>

<style lang="scss" module>
@import '@/assets/variables';

.tenantPlusIcon {
  margin: auto;
}
</style>
